export default __webpack_public_path__ + "open-sans-v18-latin-300.woff2";